// dropdowns.js

export const INITIAL_STATE = {
  isTimeSelectorOpen: false,
  isUserDropdownOpen: false,
};

// action types
const CLOSE_DROPDOWN = "trace-web/dropdowns/CLOSE_DROPDOWN";
const TOGGLE_DROPDOWN = "trace-web/dropdowns/TOGGLE_DROPDOWN";

// reducer
const dropdownReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLOSE_DROPDOWN:
      return {
        ...state,
        [action.dropdown]: false,
      };
    case TOGGLE_DROPDOWN:
      return {
        ...state,
        [action.dropdown]: !state[action.dropdown],
      };
    default:
      return state;
  }
};
export default dropdownReducer;

// action creators
export const toggleDropdown = dropdown => {
  return {
    type: TOGGLE_DROPDOWN,
    dropdown,
  };
};

export const closeDropdown = dropdown => {
  return {
    type: CLOSE_DROPDOWN,
    dropdown,
  };
};
